import React, {Component} from 'react';
import MapGL from 'react-map-gl';
import DeckGLOverlay from './deckgl-overlay';
import {LayerControls, HEXAGON_CONTROLS} from './layer-controls';
import Charts from './charts';
import lionData from './data/mtnLionData';
import {tooltipStyle, sidebar} from './style';

// const MAPBOX_STYLE = 'mapbox://styles/mapbox/dark-v9';
const MAPBOX_STYLE = 'mapbox://styles/nathanielrindlaub/cjkvhhclcbfuo2snxo46anh3w';
// const MAPBOX_TOKEN = process.env.MapboxAccessToken;
const MAPBOX_TOKEN = 'pk.eyJ1IjoibmF0aGFuaWVscmluZGxhdWIiLCJhIjoiY2pqcmQ4cTU4MmdvaDN2bzF0Yjd5b29ucyJ9.YU0K_oBS-qHGQ8S0ExUYnQ';
if (!MAPBOX_TOKEN) {
  alert('The mapbox token is not defined. Please export it in the terminal where you typed "npm start"')
}

const COLORS = {
  sg_sb: '#fcb045',
  sa: '#89253e',
  ep: '#3a6186'
};

export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        longitude: -117,
        latitude: 33.3,
        zoom: 8,
        maxZoom: 16
      },
      settings: Object.keys(HEXAGON_CONTROLS).reduce((accu, key) => ({
        ...accu,
        [key]: HEXAGON_CONTROLS[key].value
      }), {}),
      highlightedLion: null
    };
    this._resize = this._resize.bind(this);
  }

  componentDidMount() {
    this._processData();
    window.addEventListener('resize', this._resize);
    this._resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  _processData() {
    if (lionData) {

      this.setState({status: 'LOADED'});

      const data = lionData.reduce((accu, curr) => {
        if (!isNaN(curr.sa) && !isNaN(curr.longitude) && !isNaN(curr.latitude)) {

          if(!accu.lionsObj.hasOwnProperty(curr.lion)) {
            accu.lionsObj[curr.lion] = {
              sg_sb: Number(curr.sg_sb),
              sa: Number(curr.sa),
              ep: Number(curr.ep),
              geo_region: String(curr.geo_region)
            }
          }

          accu.points.push({
            position: [Number(curr.longitude), Number(curr.latitude)],
            lion: String(curr.lion),
            sg_sb: Number(curr.sg_sb),
            sa: Number(curr.sa),
            ep: Number(curr.ep),
            geo_region: String(curr.geo_region)
          });

        }
        return accu;
      }, {
        points: [],
        lionsObj: {}
      });

      let geneland = {
        sg_sb: [],
        sa: [],
        ep: []
      };
      Object.entries(data.lionsObj).forEach(([lion, geneticData]) => {
        geneland.sg_sb.push({lion: lion, x: geneticData.sg_sb, y: lion, region: geneticData.geo_region});
        geneland.sa.push({lion: lion, x: geneticData.sa, y: lion, region: geneticData.geo_region});
        geneland.ep.push({lion: lion, x: geneticData.ep, y: lion, region: geneticData.geo_region});
      });

      const compareByRegion = (a, b) => {
        	if (a.region.toLowerCase() < b.region.toLowerCase()) {
        		return -1;
        	};
        	if (a.region.toLowerCase() > b.region.toLowerCase()) {
        		return 1;
        	};
        	return 0;
      }

      geneland.sg_sb.sort(compareByRegion);
      geneland.sa.sort(compareByRegion);
      geneland.ep.sort(compareByRegion);

      data.geneland = geneland;
      data.status = 'READY';
      this.setState(data);

    }
  }

  _resize() {
    this._onViewportChange({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  _onViewportChange(viewport) {
    this.setState({
      viewport: {...this.state.viewport, ...viewport}
    });
  }

  _onHover({x, y, object}) {
    if (object) {
      this.setState({x, y, hoveredObject: object});
    } else {
      this.setState({hoveredObject: null});
    }
  }

  _updateLayerSettings(settings) {
    this.setState({settings});
  }

  _onHighlight(lion) {
    this.setState({highlightedLion: lion});
  }

  render() {

    return (
      <div>
        {this.state.hoveredObject &&
          <div style={{
            ...tooltipStyle,
            transform: `translate(${this.state.x}px, ${this.state.y}px)`
          }}>
            {Object.keys(this.state.hoveredObject).map(key =>
              <div key={key}>
                <label>{key}: </label>
                <div style={{display: 'inline-block', float: 'right'}}>
                  {this.state.hoveredObject[key]}
                </div>
              </div>)}
          </div>
        }
        <MapGL
          {...this.state.viewport}
          mapStyle={MAPBOX_STYLE}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          onViewportChange={viewport => this._onViewportChange(viewport)}>
            <DeckGLOverlay
              width={this.state.viewport.width}
              height={this.state.viewport.height}
              viewport={this.state.viewport}
              data={this.state.points}
              colors={COLORS}
              geneticFilter={this.state.settings.genelandScale}
              highlightedLion={this.state.highlightedLion}
              onHover={hover => this._onHover(hover)}
              {...this.state.settings}/>
        </MapGL>
        <Charts
          colors={COLORS}
          highlight={lion => this._onHighlight(lion)}
          {...this.state}/>
        <LayerControls
          settings={this.state.settings}
          propTypes={HEXAGON_CONTROLS}
          onChange={settings => this._updateLayerSettings(settings)}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app.js